import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Star, BadgeCheck, Eye, Heart } from "lucide-react";
import api from "../lib/api";
import { fmt } from "../lib/format";
import { useI18n } from "../lib/i18n";

const CATEGORIES = ["all", "Food", "Lifestyle", "Mode", "Beauté", "Voyage", "Café", "Fitness", "Gastronomie"];

export default function Discover() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [creators, setCreators] = useState([]);
  const [cat, setCat] = useState("all");
  const [q, setQ] = useState("");

  const load = () => {
    api.get("/creators", { params: { category: cat, q: q || undefined } })
      .then(({ data }) => setCreators(data.creators)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);

  return (
    <div className="space-y-5 animate-fade-in">
      <div>
        <h1 className="font-heading text-2xl font-extrabold">{t("discoverCreators")}</h1>
        <p className="mt-1 text-sm text-slate-400">{t("discoverCreatorsSub")}</p>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex items-center gap-2 rounded-2xl border border-cardline bg-card2/60 px-4 py-3">
        <Search size={18} className="text-slate-400" />
        <input
          data-testid="discover-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t("search")}
          className="w-full bg-transparent text-sm outline-none placeholder:text-slate-500"
        />
      </form>

      <div className="no-scrollbar flex gap-2 overflow-x-auto pb-1">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            data-testid={`cat-${c}`}
            className={`shrink-0 rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${
              cat === c ? "border-gold bg-gold text-ink" : "border-cardline bg-card2/60 text-slate-300"
            }`}
          >
            {c === "all" ? "Tous" : c}
          </button>
        ))}
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        {creators.map((c) => {
          const video = (c.portfolio || []).find((m) => m && typeof m === "object" && m.type === "video");
          return (
          <button
            key={c.id}
            onClick={() => navigate(`/creators/${c.id}`)}
            data-testid={`creator-card-${c.id}`}
            className="group overflow-hidden rounded-2xl border border-cardline bg-card2/60 text-left transition-colors hover:border-gold/60"
          >
            <div className="relative h-28">
              {video ? (
                <video src={video.src} poster={video.poster} autoPlay muted loop playsInline preload="metadata"
                  data-testid={`creator-video-${c.id}`} className="h-full w-full object-cover" />
              ) : (
                <img src={c.banner} alt="" className="h-full w-full object-cover opacity-70" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-card2/90 via-transparent" />
              <img src={c.avatar} alt={c.name} className="absolute -bottom-6 left-4 h-14 w-14 rounded-full border-2 border-card2 object-cover" />
            </div>
            <div className="p-4 pt-7">
              <div className="flex items-center gap-1.5">
                <span className="font-heading font-semibold">{c.name}</span>
                {c.verified && <BadgeCheck size={15} className="text-gold" />}
              </div>
              <div className="text-xs text-slate-400">{c.location}</div>
              <div className="mt-2 flex flex-wrap gap-1">
                {c.categories?.slice(0, 3).map((k) => (
                  <span key={k} className="rounded-full bg-ink2/70 px-2 py-0.5 text-[11px] text-slate-300">{k}</span>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between text-xs text-slate-300">
                <span className="flex items-center gap-1"><Heart size={13} className="text-red-400" /> {fmt(c.followers)}</span>
                <span className="flex items-center gap-1"><Eye size={13} className="text-sky-400" /> {fmt(c.avg_views)}</span>
                <span className="flex items-center gap-1"><Star size={13} className="text-gold" fill="currentColor" /> {c.rating}</span>
              </div>
            </div>
          </button>
          );
        })}
      </div>
      {creators.length === 0 && <p className="py-10 text-center text-sm text-slate-500">—</p>}
    </div>
  );
}
